import { PRODUCT, SECONDARY_PRODUCT } from "@/constants";

const brandImpactHelpOverlay = {
  staysure: false,
  avanti: false,
  expat: true,
};

const brandImpactConfirmation = {
  staysure: false,
  avanti: false,
  expat: true,
};

const brand: "staysure" | "avanti" | "expat" =
  SECONDARY_PRODUCT === "expat"
    ? "expat"
    : ((PRODUCT as "staysure" | "avanti") ?? "staysure");

export const isHelpOverlayCallNumberBrandImpact = brandImpactHelpOverlay[brand];
export const isConfirmationNumberBrandImpact = brandImpactConfirmation[brand];

export const isAndroid = /Android/i.test(navigator.userAgent);
